import { useEffect, useState } from 'react';

/** Returns a value that lags `source` by `delayMs`, useful for debouncing
 *  search inputs before firing a fetch. */
export function useDebouncedValue<T>(source: T, delayMs: number): T {
    const [debounced, setDebounced] = useState(source);
    useEffect(() => {
        const t = window.setTimeout(() => setDebounced(source), delayMs);
        return () => window.clearTimeout(t);
    }, [source, delayMs]);
    return debounced;
}
